import React,{ChangeEvent,useState,useCallback,useEffect} from "react";
import { useLocation } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination} from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import "Assets/css/GameLnch.css";



const GameLnchUi = () => {
    const { data: langData }:any = UseLangLstQuery();
    const location= useLocation();
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let getLangCd = query.get("langCd");
    const [ctntCtgrCdCdState,setctntCtgrCdCdState] = useState("PNOT");
    useEffect(()=> {
        CtntTop5InqApi(getGameSvcCd,ctntCtgrCdCdState).then((resp)=> {
            setCtntCtxtState(resp.apiBody.ctntLst);
        });
    },[]);
    const ctntCtxtFunc = (ctntCtgrCdCd:string) => {
        CtntTop5InqApi(getGameSvcCd,ctntCtgrCdCd).then((resp)=> {
            setctntCtgrCdCdState(ctntCtgrCdCd)
            setCtntCtxtState(resp.apiBody.ctntLst);
        });
    }
    return (
        <>
        <div className={`${"GameSvc"+getGameSvcCd}`+"gameLnchUiWrap"}>
            <div className="gameLnchBg">
                <img src={process.env.PUBLIC_URL + "/images/testbnr.png"} alt="" />
            </div>
            <div className="gameLnchRightWrap">
                <div className="ctntLstWrap">
                    <div className="ctntBtnWrap">
                        <ul>
                            <li onClick={()=>ctntCtxtFunc("PNOT")}>
                                <p>{langData && langData.GAME_LNCH_PNOT_TITL_00 || "공지사항"}</p>
                            </li>
                            <li onClick={()=>ctntCtxtFunc("EVNT")}>
                                <p>{langData && langData.GAME_LNCH_EVNT_TITL_00 || "이벤트"}</p>
                            </li>
                        </ul>
                    </div>
                    <ul className="ctntLstUl">
                        {ctntCtxtState&&ctntCtxtState.map((key:any)=>(
                            <li>
                                <a target="_blank" href={`/gamepage/ctnt/ctntCtxt?gameSvcCd=${getGameSvcCd}&ctntCtgrCd=${ctntCtgrCdCdState}&ctntSno=${key.ctntSno}`}>
                                    <p className="ctntTitlTxt">{key.ctntTitl}</p>
                                    <p>{key.aplyStrtDtime}</p>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* <div className="evntBnrSlideWrap">
                <Swiper
                spaceBetween={0}
                centeredSlides={true}
                autoplay={{
                delay: 10000,
                disableOnInteraction: false,
                }}
                pagination={{
                clickable: true,
                }}
                modules={[Autoplay, Pagination]}
                className="eventSlide"
                >
                    {}
                    <SwiperSlide>
                        <div>
                            <a  href="/" target="_blank">
                                <img src={process.env.PUBLIC_URL + "/images/testbnr.png"} alt="" />
                            </a>
                        </div>
                    </SwiperSlide>
                </Swiper>
                </div> */}
            </div>
        </div>
        </>
    )
}

export default GameLnchUi;
